import { render, staticRenderFns } from "./InternationalFederationForm.vue?vue&type=template&id=7be298c9&"
import script from "./InternationalFederationForm.vue?vue&type=script&lang=js&"
export * from "./InternationalFederationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports